import { createAction, props } from '@ngrx/store';
import { StoreModel } from '../../interfaces/store-interfaces';

export const loadStores = createAction('[Store] Load Stores');

export const loadStoresSuccess = createAction(
  '[Store] Load Stores Success',
  props<{ stores: StoreModel[] }>() // Payload with the retrieved stores
);

export const loadStoresFailure = createAction(
  '[Store] Load Stores Failure',
  props<{ error: string }>() // Payload with the error message
);

export const selectStore = createAction(
  '[Store] Select Store',
  props<{ store: StoreModel }>() // Payload with the selected store
);
